export enum Status {
  NOT_STARTED = "neînceput",
  IN_PROGRESS = "în curs de desfăşurare",
  FINISHED = "finalizat",
}
